import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../context/SubscriptionContext';
import { X, Crown, Clock, AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';
import { useState } from 'react';

const UpgradeBanner = () => {
  const navigate = useNavigate();
  const { 
    subscription, 
    trialNotification, 
    isInTrial, 
    isTrialExpired, 
    getTrialDaysRemaining,
    shouldShowUpgradeBanner,
    hasPaidPlan
  } = useSubscription();
  
  const [dismissed, setDismissed] = useState(false);

  // Ne rien afficher si plan payant ou bannière rejetée
  if (hasPaidPlan() || dismissed) return null;

  // Déterminer le type de bannière à afficher
  let bannerType = null;
  let message = '';
  let bgColor = '';
  let textColor = '';
  let Icon = Crown;

  if (trialNotification?.show_notification) {
    if (trialNotification.type === 'expired') {
      bannerType = 'expired';
      message = trialNotification.message;
      bgColor = 'bg-amber-50 border-amber-200';
      textColor = 'text-amber-800';
      Icon = AlertTriangle;
    } else if (trialNotification.type === 'ending_soon') {
      bannerType = 'ending_soon';
      message = trialNotification.message;
      bgColor = 'bg-blue-50 border-blue-200';
      textColor = 'text-blue-800';
      Icon = Clock;
    }
  } else if (shouldShowUpgradeBanner()) {
    bannerType = 'upgrade';
    message = 'Passez à Solo pour débloquer toutes les fonctionnalités';
    bgColor = 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200';
    textColor = 'text-blue-800';
    Icon = Crown;
  }

  if (!bannerType) return null;

  return (
    <div 
      className={`${bgColor} border-b px-4 py-3 flex items-center justify-between gap-4`}
      data-testid="upgrade-banner"
    >
      <div className="flex items-center gap-3 flex-1">
        <div className={`p-1.5 rounded-full ${bannerType === 'expired' ? 'bg-amber-100' : 'bg-blue-100'}`}>
          <Icon className={`h-4 w-4 ${bannerType === 'expired' ? 'text-amber-600' : 'text-blue-600'}`} />
        </div>
        <div className="flex-1">
          <p className={`text-sm font-medium ${textColor}`}>
            {message}
          </p>
          {isInTrial() && (
            <p className="text-xs text-slate-500 mt-0.5">
              {getTrialDaysRemaining()} jour{getTrialDaysRemaining() > 1 ? 's' : ''} restant{getTrialDaysRemaining() > 1 ? 's' : ''} dans votre essai gratuit
            </p>
          )}
          {isTrialExpired() && subscription?.exports_remaining !== undefined && (
            <p className="text-xs text-slate-500 mt-0.5">
              {subscription.exports_remaining} export{subscription.exports_remaining !== 1 ? 's' : ''} restant{subscription.exports_remaining !== 1 ? 's' : ''} cette année
            </p>
          )}
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          className="bg-blue-600 hover:bg-blue-700 text-white"
          onClick={() => navigate('/pricing')}
          data-testid="upgrade-cta-btn"
        >
          <Crown className="h-3.5 w-3.5 mr-1.5" />
          Passer à Solo
        </Button>
        {bannerType !== 'expired' && (
          <button
            onClick={() => setDismissed(true)}
            className="p-1.5 hover:bg-white/50 rounded-full transition-colors"
            aria-label="Fermer"
          >
            <X className="h-4 w-4 text-slate-400" />
          </button>
        )}
      </div>
    </div>
  );
};

export default UpgradeBanner;
